import { render, staticRenderFns } from "./TeamMembersCollector.vue?vue&type=template&id=0d71ecc4"
import script from "./TeamMembersCollector.vue?vue&type=script&lang=js"
export * from "./TeamMembersCollector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports